<template>
  <v-main class="page-form-main-form">
    <portal to="app-bar">
      <v-app-bar
        app
        color="secondary"
        dark
      >
        <v-toolbar-title>{{ project ? project.name : $t('form.show.main-form') }}</v-toolbar-title>
      </v-app-bar>
    </portal>

    <v-container v-if="project">
      <FormComponent
        v-model="formData"
        :form="project.formMain"
        type="main"
        doc-id=""
        validate
        @submit="saveForm"
      />
    </v-container>
  </v-main>
</template>

<script>
import FormComponent from '@/components/FormComponent';
import axios from 'axios';

export default {
  components: {
    FormComponent
  },
  data: () => ({
    http: null,
    project: null,
    internalFormData: null
  }),
  computed: {
    formData: {
      get () {
        return this.internalFormData || {};
      },
      set (v) {
        this.internalFormData = v;
      }
    }
  },
  mounted () {
    if (this.$store.getters['auth/check']) {
      this.startForm();
    } else {
      this.http = axios.create({
        withCredentials: true,
        baseURL: window.localStorage.getItem('instanceURL') || process.env.VUE_APP_API_ENDPOINT
      });

      if (this.$route.params.code && this.$route.params.id && this.$route.params.id.match(/d\-([0-9])+/)) {
        this.startPrivateForm();
      } else {
        this.startPublicForm();
      }
      // TODO: Ability to start form without login
      // this.$router.push('/');
    }
  },
  methods: {
    async startPublicForm () {
      const projectId = this.$route.params.id;
      const { data } = await this.http.get(`/public/project/${projectId}`);

      this.project = {
        _id: data.id,
        name: data.name,
        formHead: data.form_head,
        formMain: data.form_main,
        description: data.description,
        descriptionFile: data.file,
        formHeadData: data.form_head_data,
        groups: [],
        status: data.status,
        createdAt: data.created_at,
        updatedAt: data.updated_at,
        deleted: data.deleted,
        synced: true,
        lastUpdate: data.time
      };
    },
    async startPrivateForm() {
      const id = this.$route.params.id.substr(2);
      const code = this.$route.params.code;
      const { data } = await this.http.get(`/public/project/0/data/${id}`, {
        params: {
          token: code
        }
      });

      let project = data.project;
      this.project = {
        _id: project.id,
        name: project.name,
        formHead: project.form_head,
        formMain: project.form_main,
        description: project.description,
        descriptionFile: project.file,
        formHeadData: project.form_head_data,
        groups: [],
        status: project.status,
        createdAt: project.created_at,
        updatedAt: project.updated_at,
        deleted: project.deleted,
        synced: true,
        lastUpdate: project.time
      };
      this.formData = data.data;
    },
    async startForm () {
      const projectId = this.$route.params.id;
      const { data } = await axios.get(`/project/${projectId}`);

      try {
        const oldDoc = await this.$pouch.get(projectId, {}, 'projects');
        this.oldDoc.status = 1;
        await this.$pouch.put(oldDoc, { force: true }, 'projects');
      } catch (e) {}
      const doc = await this.$pouch.post({
        externalId: null,
        createdAt: (new Date()).toISOString(),
        data: {},
        form: data.form_main,
        projectId,
        lastUpdate: null,
        sentAt: null,
        synced: false
      }, null, 'project_data');
      this.$router.push({ name: 'form.show', params: { id: doc.id } });
    },
    async saveForm (v) {
      const loader = this.$loading.show();

      for (const key in v) {
        if (v[key] && v[key].blob instanceof Blob) {
          const file = v[key].blob;

          const formData = new FormData();
          formData.append('file', new File([v[key].blob], v[key].name));
          try {
            const response = await this.http.post('/public/storage/app_upload', formData, {
              headers: { 'Content-Type': 'multipart/form-data' }
            });

            v[key] = response.data;
          } catch (e) {
            console.error(e, data);
          }
        }
      }

      if (this.$route.params.code && this.$route.params.id && this.$route.params.id.match(/d\-([0-9])+/)) {
        const id = this.$route.params.id.substr(2);
        const code = this.$route.params.code;

        await this.http.patch(`/public/project/${this.project._id}/data/${id}`, {
          data: JSON.stringify(v),
          token: code
        });
        await this.http.get(`/public/project/${this.project._id}/data/${id}/send`, {
          params: {
            token: code
          }
        });
      } else {
        const { data } = await this.http.post(`/public/project/${this.project._id}/data`, {
          uid: this.$route.params.code || undefined
        });

        await this.http.patch(`/public/project/${this.project._id}/data/${data.id}`, {
          data: JSON.stringify(v)
        });
        await this.http.get(`/public/project/${this.project._id}/data/${data.id}/send`);
      }
      // this.$router.go(-1);
      loader.hide();

      this.$router.push({ name: 'form.sent', params: { id: this.project._id, name: this.project.name } });
    }
  }
};
</script>
